<template>
  <div>
    <site-header></site-header>
    <div class="carousel" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
      <div class="carousel-track" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div class="carousel-slide" v-for="(img, index) in carouselImages" :key="index">
          <img :src="img" alt="轮播图" class="main-image">
        </div>
      </div>
      <div class="carousel-dots">
        <span v-for="(img, index) in carouselImages" :key="index"
          :class="['carousel-dot', { active: currentIndex === index }]"
          @click="goTo(index)"></span>
      </div>
      <button class="carousel-btn carousel-prev" @click="prev">&#8249;</button>
      <button class="carousel-btn carousel-next" @click="next">&#8250;</button>
    </div>
    <div class="slogan-banner">
      <div class="slogan-item">把专业做到引领</div>
      <div class="slogan-item">把服务做到精准</div>
    </div>
    <div class="content-wrapper">
    <div id="news" class="news-section">
      <div class="news-main">
        <div class="news-header">
          <div class="news-title-zh">新闻动态</div>
          <div class="news-title-en">News and Trends</div>
        </div>
        <div class="news-content">
          <!-- 顶部大图：第一条新闻 -->
          <div class="news-featured" v-if="newsList.length > 0" @click="goToDetails(newsList[0], 'news')">
            <img :src="newsList[0].messageImg" class="news-featured-img" />
            <div class="news-featured-title">{{ newsList[0].messageName }}</div>
          </div>
          <!-- 底部左右结构 -->
          <div class="news-bottom">
            <!-- 左侧：第2、3、4条带小图 -->
            <div class="news-bottom-left">
              <div class="news-thumb-item" v-for="(item, index) in newsList.slice(1, 4)" :key="item.id || index"
                @click="goToDetails(item, 'news')">
                <img :src="item.messageImg" class="news-thumb-img" />
              </div>
            </div>
            <!-- 右侧：剩余新闻列表 -->
            <div class="news-bottom-right">
              <ul class="news-list">
                <li v-for="(item, index) in newsList.slice(4, 30)" :key="item.id || index" class="news-list-item"
                  @click="goToDetails(item, 'news')">
                  <span class="news-title2">{{ item.messageName }}</span>
                </li>
              </ul>
              <div class="news-more-wrap">
                <span class="news-more-btn" @click="$router.push('/news')">MORE <span
                    class="more-arrow">&rsaquo;</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div class="banner-ad">
      <el-carousel trigger="hover" arrow="always" :autoplay="false" v-if="towBannerArr.length"
        indicator-position="none">
        <el-carousel-item v-for="item in towBannerArr" :key="item.id">
          <div class="ad-slide-content">
            <img :src="item.url" alt="广告" class="ad-image">
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div id="project" class="project-research-section">
      <div class="project-research-main">
        <div class="news-header">
          <div class="news-title-zh">项目研究</div>
          <div class="news-title-en">Project research</div>
        </div>
        <div class="project-research-content">
          <div class="pr-left" v-if="projectResearchList.length" @click="goToProjectDetails(projectResearchList[0])">
            <div class="pr-cover-wrap">
              <img :src="projectResearchList[0].cover" :alt="projectResearchList[0].title" class="pr-cover-img" />
            </div>
            <div class="pr-introduce" v-html="projectResearchList[0].title"></div>
            <div class="pr-content">{{ projectResearchList[0].content }}</div>
          </div>
        </div>
        <div class="news-more-wrap">
                <span class="news-more-btn" @click="$router.push('/project')">MORE <span
                    class="more-arrow">&rsaquo;</span></span>
              </div>
      </div>
    </div>

    <div id="lantai-study" class="lantai-study-section">
      <div class="lantai-study-main">
        <div class="ls-header">
          <div class="news-title-zh">兰台研读</div>
          <div class="news-title-en">Archives Research</div>
        </div>
        <div class="ls-bg">
          <div class="ls-cards">
            <div class="ls-card" v-for="(card, index) in lantaiStudyCards" :key="index" @click="$router.push('/volume?category=' + card.type)">
              <div class="ls-card-title">{{ card.title }}</div>
            </div>
          </div>
        </div>
        <div class="news-more-wrap">
          <span class="news-more-btn" @click="$router.push('/volume?category=1')">MORE <span class="more-arrow">&rsaquo;</span></span>
        </div>
      </div>
    </div>

    <div id="archives" class="archives-research-section">
      <div class="archives-research-main">
       
        <div class="ls-header">
          <div class="news-title-zh">专家团队</div>
          <div class="news-title-en">Expert Team</div>
        </div>
        <div class="ar-list-wrap">
          <div class="ar-list">
            <div v-for="(person, index) in specialistList" :key="person.id || index" class="ar-item"
              @click="goToDetails(person, 'specialist')">
              <div class="ar-photo-wrap">
                <img :src="person.photograph" :alt="person.name" class="ar-photo" />
              </div>
              <div class="ar-left">
                <div class="ar-name">{{ person.name }}</div>
                <div v-if="person.unit" class="ar-unit">{{ person.unit }}</div>
                <div v-if="person.position" class="ar-position">{{ person.position }}</div>
              </div>
              <div v-if="person.introduce" class="ar-introduce-wrap">
                <div class="ar-introduce-label">介绍</div>
                <div class="ar-introduce" v-html="person.introduce"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="ar-more-wrap">
          <button class="ar-more-btn" @click="$router.push('/volume?category=4')">查看更多 <span
              style="font-size:18px;vertical-align:middle;">&rsaquo;</span></button>
        </div> -->
        <div class="news-more-wrap">
          <span class="news-more-btn" @click="$router.push('/volume?category=4')">MORE <span class="more-arrow">&rsaquo;</span></span>
        </div>
      </div>
    </div>
    
    <div id="policy" class="policy-section">
      <div class="policy-main">
        <div class="ls-header">
          <div class="news-title-zh">政策法规</div>
          <div class="news-title-en">Policy and Regulations</div>
        </div>
        <div class="policy-content">
          <div class="policy-left">
            <div v-for="(item, index) in policyList" :key="item.id || index"
              :class="['policy-left-item', { active: policyActiveIndex === index }]"
              @click="goToPolicyDetail(item, '1')">
              {{ item.title }}
            </div>
          </div>
          <div class="policy-right">
            <div v-for="(item, index) in regulationList" :key="item.id || index"
              class="policy-right-item" @click="goToPolicyDetail(item, '2')">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="news-more-wrap">
          <span class="news-more-btn" @click="$router.push('/policy')">MORE <span class="more-arrow">&rsaquo;</span></span>
        </div>
      </div>
    </div>
    </div>

    <site-footer></site-footer>
  </div>
</template>

<script>
import siteHeader from "../components/SiteHeader.vue";
import siteFooter from "../components/SiteFooter.vue";
import { getNewsMessage, getSpecialist, getLtItemDaList, getLtCodificationDalist } from "@/api/website";
import { getPictureList } from "@/api/apis";

export default {
  name: "HomePage",
  components: {
    siteHeader,
    siteFooter,
  },
  data() {
    return {
      carouselImages: [
        require('@/assets/01.jpg'),
        require('@/assets/02.jpg'),
        require('@/assets/03.jpg'),
        require('@/assets/04.jpg'),
      ],
      currentIndex: 0,
      autoPlayTimer: null,
      newsList: [], // 新闻列表
      specialistList: [], // 专家列表（仅position含"专家"的数据）
      projectResearchList: [], // 项目研究列表
      lantaiStudyCards: [
        { title: '教学计划', type: '1' },
        { title: '课程规划', type: '2' },
        { title: '课程录播', type: '3' },
      ],
      policyList: [],
      regulationList: [],
      policyActiveIndex: 0,
      towBannerList: [],
    };
  },
  created() {
    this.fetchNews();
    this.fetchSpecialists();
    this.fetchProjectResearch();
    this.fetchPolicyAndRegulations();
    this.getTwoBanners();
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.carouselImages.length;
    },
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.carouselImages.length) % this.carouselImages.length;
    },
    goTo(index) {
      this.currentIndex = index;
    },
    startAutoPlay() {
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => { this.next(); }, 3000);
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    goToDetails(item, type) {
      const query = {};
      switch (type) {
        case 'news':
          query.id = item.id;
          this.$router.push({
            path: '/details',
            query: query
          });
          break;
        case 'specialist':
        case 'teacher':
          this.$router.push({
            path: '/expert-detail',
            query: { [type]: item }
          });
          break;
        case 'item':
          query.item = item; // Pass the whole item for project research (assuming 'item' type)
          this.$router.push({
            path: '/details',
            query: query
          });
          break;
        // Add more cases for other types if needed
        default:
          // Fallback or error handling if type is unknown
          console.error("Unknown item type for navigation:", type);
          return; // Prevent navigation for unknown types
      }
    },
    goToProjectDetails(item) {
      this.$router.push({
        path: '/ProjectDetails',
        query: {
          id: item.id,
          type: 'project'
        }
      });
    },
    goToPolicyDetail(item, type) {
      this.$router.push({
        name: 'details',
        query: {
          id: item.id,
          type: type,
          title: item.title,
          releaseTime: item.releaseTime,
          from: 'policy'
        }
      });
    },
    async fetchNews() {
      try {
        const res = await getNewsMessage({ pageNum: 1, pageSize: 30 });
        if (res && res.rows) {
          this.newsList = res.rows;
        }
      } catch (e) {
        console.error("获取新闻列表失败:", e);
      }
    },
    async fetchSpecialists() {
      try {
        const res = await getSpecialist();
        if (res && res.rows) {
          this.specialistList = res.rows.filter(
            item => item.position && item.position.includes('专家')
          );
        }
      } catch (e) {
        console.error("获取专家列表失败:", e);
      }
    },
    async fetchProjectResearch() {
      try {
        const res = await getLtItemDaList();
        if (res && res.rows) {
          this.projectResearchList = res.rows;
        }
      } catch (e) {
        console.error("获取项目研究列表失败:", e);
      }
    },
    async fetchPolicyAndRegulations() {
      try {
        const [policyRes, regRes] = await Promise.all([
          getLtCodificationDalist({ type: 1, pageNum: 1, pageSize: 6 }),
          getLtCodificationDalist({ type: 2, pageNum: 1, pageSize: 6 }),
        ]);
        if (policyRes && policyRes.rows) {
          this.policyList = policyRes.rows;
        }
        if (regRes && regRes.rows) {
          this.regulationList = regRes.rows;
        }
      } catch (e) {
        console.error("获取政策法规失败:", e);
      }
    },
    goToVolumeExpert() {
      this.$router.push('/volume?category=4');
    },
  async getTwoBanners() {
    try {
      const res = await getPictureList();
      if (res.code === 200) {
        // 筛选出 location 为 2 的轮播图数据（广告横幅）
        this.towBannerList = res.rows
          .filter(item => item.location === 2)
          .map((item) => ({
            id: item.id,
            url: item.carouselUrl,
            title: "",
            subtitle: "",
            description: item.remark || "",
          }));
      }
    } catch (error) {
      console.error("获取广告横幅轮播图失败：", error);
    }
  },
  },
  computed: {
  towBannerArr() {
    return this.towBannerList;
  }
}
};
</script>

<style scoped>

.carousel {
  width: 79.17%;
  max-width: 1520px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  border-radius: 0;
}

.carousel-track {
  display: flex;
  width: 100%;
  transition: transform 0.6s ease-in-out;
}

.carousel-slide {
  width: 100%;
  min-width: 100%;
  flex-shrink: 0;
}

.carousel-slide .main-image {
  width: 100%;
  height: auto;
  display: block;
}

.carousel-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 2;
}

.carousel-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s;
}

.carousel-dot.active {
  background: #fff;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.25);
  color: #fff;
  border: none;
  font-size: 36px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
  line-height: 1;
}

.carousel-btn:hover {
  background: rgba(0, 0, 0, 0.5);
}

.carousel-prev {
  left: 16px;
}

.carousel-next {
  right: 16px;
}


.slogan-banner {
  background-color: #f8f8f8;
  width: 79.17%;
  max-width: 1520px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 120px;
  padding: 12px 0;
}

.slogan-item {
  font-size: 15px;
  color: #ab614a;
  letter-spacing: 40px;
  text-align: center;
  white-space: nowrap;
}


.content-wrapper {
  width: 79.17%;
  max-width: 1520px;
  margin: 0 auto;
  background: #f8f8f8;
  border-radius: 0;
}

.news-section {
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0 0;
}

.news-main {
  width: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 20px 110px 16px;
  position: relative;
  margin-top: 0;
}

.news-header {
  width: 100%;
  font-size: 28px;
  color: #8b4513;
  font-weight: 600;
  text-align: left;
  letter-spacing: 1px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.news-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.news-featured {
  width: 100%;
  position: relative;
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
}

.news-featured-img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  display: block;
}

.news-featured-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(172, 98, 73, 0.55);
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 14px 24px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.news-featured:hover .news-featured-title {
  background: rgba(172, 98, 73, 0.7);
}

.news-bottom {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.news-bottom-left {
  flex: 0 0 243px;
  height: 700px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.news-thumb-item {
  flex: 1;
  cursor: pointer;
  border-radius: 0;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}

.news-thumb-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(173, 99, 74, 0.15);
}

.news-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.news-bottom-right {
  padding-left: 60px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 0;
  height: 700px;
}

.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 40px;
  flex: 1;
  min-height: 0;
  align-content: start;
}

.news-list-item {
  font-size: 11px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding: 16px 0;
  cursor: pointer;
  transition: color 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.news-list-item:hover .news-title2 {
  color: #ad634a;
  text-decoration: underline;
}

.news-title2 {
  transition: color 0.2s;
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-more-wrap {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
}

.news-more-btn {
  display: inline-block;
  border: none;
  border-radius: 0;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  color:#ab6249;
  transition: background 0.2s;
}

.more-arrow {
  font-size: 18px;
  vertical-align: middle;
}


.archives-research-section {
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.archives-research-main {
  width: 100%;
  background: transparent;
  border-radius: 0;
  box-sizing: border-box;
  display: block;
  position: relative;
  margin-top: 0;
  padding: 16px 110px 24px 110px;
}

.archives-research-header {
  width: 100%;
  text-align: left;
  margin-bottom: 30px;
  box-sizing: border-box;
}

.ar-list-wrap {
  display: block;
  min-width: 0;
}

.ar-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 30px;
}

.ar-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  background: #fff;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 24px;
  gap: 24px;
}

.ar-item:hover {
  background: #fdf3ea;
  box-shadow: 0 4px 16px rgba(173, 99, 74, 0.12);
}

.ar-photo-wrap {
  flex-shrink: 0;
  width: 160px;
  height: 200px;
  border-radius: 0;
  overflow: hidden;
  background: #f5f5f5;
}

.ar-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ar-left {
  flex: 0 0 220px; /* 固定左侧宽度 */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 0;
  margin-right: 20px;
}

.ar-name {
  font-size: 20px;
  color: #222;
  font-weight: 600;
  margin-bottom: 8px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  width: 100%;
}

.ar-unit {
  font-size: 14px;
  color: #666;
  margin-bottom: 6px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  width: 100%;
}

.ar-position {
  font-size: 14px;
  color: #8b4513;
  font-weight: 500;
  margin-bottom: 10px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  width: 100%;
}

.ar-introduce-wrap {
  flex: 1; /* 让介绍区域占据剩余空间 */
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 100%; /* 确保不会超出容器 */
}

.ar-introduce-label {
  font-size: 20px;
  color: #222;
  font-weight: 600;
  margin-bottom: 8px;
}

.ar-introduce {
  font-size: 14px;
  color: #555;
  line-height: 1.8;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.ar-introduce :deep(p) {
  margin: 0;
  padding: 0;
}

.ar-more-wrap {
  position: absolute;
  bottom: 30px;
  right: 40px;
}

.ar-more-btn {
  background: #ad634a;
  color: #fff;
  border: none;
  border-radius: 0;
  padding: 10px 36px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.ar-more-btn:hover {
  background: #8b4513;
}

.lantai-study-section {
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  padding: 0;
}

.lantai-study-main {
  width: 100%;
  background: transparent;
  border-radius: 0;
  box-sizing: border-box;
  padding: 16px 110px 20px;
  display: flex;
  flex-direction: column;
}

.ls-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 30px;
}

.ls-bg {
  width: 100%;
  min-height: 460px;
  background: url('~@/assets/beijing.jpg') center center / cover no-repeat;
  border-radius: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ls-bg::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.15);
}

.ls-cards {
  display: flex;
  gap: 85px;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding: 60px 0;
}

.ls-card {
  width: 205px;
  height: 160px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;
}

.ls-card:hover {
  background: #ac6249;
}

.ls-card:hover .ls-card-title {
  color: #fff;
}

.ls-card-title {
  font-size: 20px;
  font-weight: 600;
  color: #ac6249;
  letter-spacing: 2px;
  transition: color 0.3s;
}

.project-research-section {
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.project-research-main {
  width: 100%;
  background: transparent;
  border-radius: 0;
  box-sizing: border-box;
  padding: 16px 110px 20px;
  display: flex;
  flex-direction: column;
}

.project-research-header {
  width: 100%;
  font-size: 28px;
  color: #8b4513;
  font-weight: 600;
  margin-bottom: 30px;
  /* Space below header */
  text-align: left;
  letter-spacing: 1px;
}

.project-research-content {
  display: flex;
  gap: 30px;
  /* Space between left and right columns */
}

.pr-left {
  flex: 1;
  /* Take up proportional space */
  display: flex;
  flex-direction: column;
  cursor: pointer;
  /* Add cursor pointer to indicate clickable */
}

.pr-cover-wrap {
  /* width: 100%; */
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(173, 99, 74, 0.08);
}

.pr-cover-img {
  width: 100%;
  height: auto;
  max-height: 320px;
  object-fit: cover;
  display: block;
}

.pr-introduce {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  line-height: 1.8;
  padding: 16px 0 8px;
}

.pr-content {
  font-size: 14px;
  color: #444;
  line-height: 1.8;
  padding-top: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.pr-right {
  flex: 1;
  /* Take up proportional space */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Push list to top and button to bottom */
}

.pr-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pr-list-item {
  font-size: 16px;
  color: #222;
  border-bottom: 1px solid #e5e5e5;
  padding: 12px 0;
  cursor: pointer;
  transition: color 0.2s;
  display: flex;
  justify-content: space-between;
  /* Title on left, date on right */
  align-items: center;
}

.pr-list-item:hover .pr-title {
  color: #ad634a;
  text-decoration: underline;
}

.pr-title {
  flex-grow: 1;
  /* Allow title to take up available space */
  margin-right: 10px;
  /* Space between title and date */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pr-date {
  font-size: 14px;
  color: #999;
  flex-shrink: 0;
  /* Prevent date from shrinking */
}

.pr-more-wrap {
  text-align: right;
  margin-top: 20px;
  /* Space above the button */
}

.pr-more-btn {
  background: #fff;
  color: #8b4513;
  border: 1px solid #ecb68a;
  border-radius: 0;
  padding: 10px 36px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.pr-more-btn:hover {
  background: #8b4513;
  color: #fff;
  border-color: #8b4513;
}

.pr-left-more,
.pr-right-more {
  /* Specific positioning might be needed based on final layout */
}

.news-title,
.archives-research-title,
.project-research-title {
  font-size: 28px;
  color: #8b4513;
  font-weight: 600;
  text-align: left;
  letter-spacing: 1px;
}

.news-title-zh {
  font-size: 28px;
  color: #8b4513;
  font-weight: 600;
  letter-spacing: 1px;
}

.news-title-en {
  font-size: 18px;
  font-weight: 400;
  color: #8b4513;
  letter-spacing: 1px;
}

.news-title2 {
  font-size: 14px;
}

.news-title br,
.project-research-title br {
  content: '';
  display: block;
}

.policy-section {
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  padding: 0 0 20px;
}

.policy-main {
  width: 100%;
  background: transparent;
  border-radius: 0;
  box-sizing: border-box;
  padding: 16px 110px 20px;
  display: flex;
  flex-direction: column;
}

.policy-content {
  display: flex;
  gap: 30px;
}

.policy-left,
.policy-right {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.policy-left-item,
.policy-right-item {
  font-size: 14px;
  color: #999;
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.2s;
}

.policy-right-item:hover {
  color: #8b4513;
}

.policy-left-item {
  cursor: pointer;
  transition: color 0.2s;
}

.policy-left-item:hover {
  color: #222;
  font-weight: 600;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .main-image {
    width: 100%;
    height: auto;
  }

  .carousel-btn {
    width: 36px;
    height: 36px;
    font-size: 28px;
  }

  .carousel-dot {
    width: 8px;
    height: 8px;
  }

  .slogan-banner {
    width: 100%;
    padding: 20px 16px;
    gap: 40px;
  }

  .slogan-item {
    font-size: 16px;
    letter-spacing: 4px;
  }

  .home-buttons {
    flex-direction: column;
    gap: 15px;
    margin: 20px 0;
    padding: 0 20px;
  }

  .home-button {
    width: 100%;
    min-width: auto;
    min-height: 60px;
    font-size: 18px;
  }

  .news-section {
    padding: 12px 0 0;
  }

  .archives-research-section {
    padding: 0;
  }

  .project-research-section {
    padding: 0;
  }

  .lantai-study-section {
    padding: 0;
  }

  .policy-section {
    padding: 0 0 12px;
  }

  .news-main,
  .archives-research-main,
  .project-research-main {
    width: 100%;
    margin: 10px 0;
    padding: 16px;
    border-radius: 0;
  }

  .news-header,
  .archives-research-header,
  .project-research-header {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .news-title,
  .archives-research-title,
  .project-research-title {
    font-size: 22px;
  }

  .news-title span,
  .archives-research-title span,
  .project-research-title span {
    font-size: 14px;
  }

  .news-title-zh {
    font-size: 22px;
  }

  .news-title-en {
    font-size: 14px;
  }

  .news-content {
    flex-direction: column;
    gap: 20px;
  }

  .news-featured-img {
    height: 220px;
  }

  .news-featured-title {
    font-size: 15px;
    padding: 10px 16px;
  }

  .news-bottom {
    flex-direction: column;
    gap: 20px;
  }

  .news-bottom-left {
    flex: none;
    width: 100%;
  }

  .news-thumb-img {
    aspect-ratio: 1;
  }

  .news-bottom-right {
    width: 100%;
    height: auto;
  }

  .news-list {
    width: 100%;
    grid-template-columns: 1fr;
  }

  .news-list-item {
    font-size: 14px;
    padding: 12px 0;
    width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    display: flex;
    align-items: flex-start;
  }

  .news-title2 {
    font-size: 14px;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.5;
    max-width: 100%;
    word-break: break-word;
  }

  .news-more-wrap {
    margin-top: 20px;
    justify-content: center;
  }

  .news-more-btn {
    padding: 12px 0;
    font-size: 15px;
  }

  .archives-research-main {
    padding: 16px 16px 40px 16px;
  }

  .ar-list {
    gap: 16px;
    margin-bottom: 20px;
  }

  .ar-item {
    flex-direction: column;
    align-items: center;
    padding: 16px;
    gap: 16px;
  }

  .ar-photo-wrap {
    width: 120px;
    height: 150px;
  }

  .ar-info {
    align-items: center;
    text-align: center;
  }

  .ar-name {
    font-size: 16px;
  }

  .ar-unit,
  .ar-position {
    font-size: 12px;
  }

  .ar-introduce {
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }

  .ar-honor {
    width: 80px;
  }

  .ar-honor-img {
    max-height: 100px;
  }

  .ar-more-wrap {
    bottom: 20px;
    right: 20px;
    left: 20px;
  }

  .ar-more-btn {
    width: 100%;
    padding: 12px 20px;
  }

  .project-research-content {
    flex-direction: column;
    gap: 20px;
  }

  .pr-left {
    width: 100%;
  }

  .pr-cover-img {
    height: auto;
  }

  .pr-introduce {
    font-size: 14px;
    padding: 12px 0 6px;
  }

  .pr-content {
    font-size: 13px;
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }

  .pr-right {
    width: 100%;
  }

  .pr-list-item {
    font-size: 14px;
    padding: 10px 0;
  }

  .pr-title {
    font-size: 14px;
  }

  .pr-date {
    font-size: 12px;
  }

  .pr-more-wrap {
    margin-top: 15px;
    text-align: center;
  }

  .pr-more-btn {
    width: 100%;
    padding: 12px 20px;
  }

  .policy-content {
    flex-direction: column;
    gap: 16px;
  }

  .policy-left,
  .policy-right {
    flex: none;
  }
}

/* 广告横幅样式 */
.banner-ad {
  width: 100%;
  margin: 0 auto;
  background: #f8f8f8;
  padding: 0 110px;
  box-sizing: border-box;
}

/* 确保 el-carousel 占满 banner-ad 的宽度 */
.banner-ad ::v-deep .el-carousel {
  width: 100%;
}

.ad-slide-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ad-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* 广告轮播图箭头位置 */
.banner-ad ::v-deep .el-carousel__arrow--left {
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 15px;
}

.banner-ad ::v-deep .el-carousel__arrow--right {
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: 15px;
}

/* 移动端广告横幅适配 */
@media (max-width: 768px) {
  .banner-ad {
    width: 100%;
    padding: 0 16px;
  }
  
  .ad-image {
    width: 100%;
    height: auto;
  }
  
  /* 移动端隐藏箭头 */
  .banner-ad ::v-deep .el-carousel__arrow {
    display: none;
  }
}

@media (max-width: 480px) {
  .banner-ad {
    padding: 0 16px;
  }
}
</style>
